import type { ContentHref } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { useSelector } from 'react-redux';

export const useEditHref = () => {
  return useSelector((state: RootState) => state.documentUI.currentEditingNode as ContentHref);
};
